import type { PurchasableNft } from "@/app/nft/buy/nfts-to-buy/scope"
import { Blockchain } from "@anaconda/core/blockchain/types"
import type { PriceValue } from "@anaconda/core/price/types"
import { useEvmBatchBuy } from "../evm/evm-batch-buy-molecule"
import { useSolanaBatchBuy } from "../solana/solana-batch-buy-molecule"

export function useBatchBuy(
  nfts: PurchasableNft[],
  price: PriceValue | undefined,
) {
  const evm = useEvmBatchBuy(nfts, price)
  const solana = useSolanaBatchBuy(nfts, price)
  const isSolana = nfts[0]?.collection.blockchain === Blockchain.SOLANA

  if (isSolana) {
    return solana
  }

  return evm
}
